<div class="close-button pe-1">
  <button type="button" aria-label="Close" class="btn-close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  <app-alert-ticket-summary #ticketSummaryComponent
                            [site]="site"
                            [ticket]="ticket"
                            [grabFocus]="{focus: true, options: {preventScroll: true}}"
                            [showSiteName]="showSiteName"
                            [showSiteNameAsLink]="showSiteNameAsLink"
                            [showViewAction]="showViewLinkedTicket"
                            [showOtherEscalatedTicketsCount]="showOtherEscalatedTicketsCount"
                            [showOtherEscalatedTicketsCountAsLink]="showOtherEscalatedTicketsCountAsLink"
                            [showExpandIcon]="false"
                            [readOnly]="readOnly"
                            (ticketOperation)="onTicketOperationFromSummaryComponent($event)"/>
  <app-alert-ticket-body #ticketBodyComponent
                         [ticket]="ticket"
                         [site]="site"
                         [hideInboxControl]="hideInboxControl"
                         [showViewAction]="showViewLinkedTicket"
                         [readOnly]="readOnly"
                         (ticketOperation)="onTicketOperationFromBodyComponent($event)"/>
</div>
